
import { Component, Vue } from 'vue-property-decorator';

import Form12ProcessHeader from "@/components/process/Form12/components/Form12ProcessHeader.vue";
import Form12CaseInformation from "@/components/process/Form12/components/Form12CaseInformation.vue";
import { form12StatusInfoType } from '@/types/Information/Form12';

@Component({
    components:{
        Form12ProcessHeader,
        Form12CaseInformation
    }
})
export default class StartForm12 extends Vue {

    stepsCompleted = {} as form12StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
